import React from "react";
import { colors } from '../../../../theme/colors';
import { Avatar, Box, IconButton, Tooltip, Zoom } from "@mui/material";
import SvgCamera from "../../../../assets/Icons/svg-icon-component/SvgCamera";
import CloseIcon from '@mui/icons-material/Close';
import FieldErrorMessage from "../../../../components/common-components/FieldErrorMessage";
import useUploadProfilePic from "./useUploadProfilePic";


const UploadProfilePic = ({
  setProfilePic,
  profilePic,
  getProfilePic,
  inputRef,
  clearProfilePic,
  error,
}) => {
  const {
    handleSetProfilePic,
    handleRemoveProfilePic,
    handleMouseEnter,
    handleMouseLeave,
    uploadProfilePicClasses,
  } = useUploadProfilePic({
    setProfilePic,
    profilePic,
    getProfilePic,
    inputRef,
    clearProfilePic,
  });

  return (
    <>
      <Box
        className="UploadImage"
        sx={{ 
          position: 'relative',
          '&:hover .remove-icon': {
            opacity: 1
          }
        }}
        onMouseLeave={handleMouseLeave}
        onMouseEnter={handleMouseEnter}
      >
        <input
          ref={inputRef}
          type="file"
          accept=".jpeg,.jpg,.png"
          className="upload-input"
          onChange={handleSetProfilePic}
        />
        
        {profilePic ? (
          <>
            <Avatar 
              className="profile_avtar" 
              src={profilePic} 
              onClick={() => inputRef?.current?.click()}
            />
                  <Tooltip
                            title="Remove"
                            placement="top"
                            slots={{
                              transition: Zoom,
                            }}
                            arrow
                            PopperProps={{
                              modifiers: [
                                {
                                  name: "preventOverflow",
                                  options: {
                                    boundary: "window",
                                  },
                                },
                              ],
                            }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: colors.primary,
                                  color: "#fff",
                                  fontSize: "0.875rem",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: colors.primary,
                                },
                              },
                            }}
                          >
                             <IconButton 
                className="remove-icon"
                onClick={handleRemoveProfilePic}
                sx={{
                  position: 'absolute',
                  top: -10,
                  right: -10,
                  backgroundColor: '#BEBEBE',
                  color: 'white',
                  opacity: 0,
                  transition: 'opacity 0.3s',
                  '&:hover': {
                    backgroundColor: colors.primary,
                  }
                }}
                size="small"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
                          </Tooltip>
            <Box 
              className={uploadProfilePicClasses}
              onClick={() => inputRef?.current?.click()}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <SvgCamera width="32px" height="32px" style={{ color: "#fff" }} />
                  <Box color={"#fff"}>Change Photo</Box>
                </Box>
            </Box>
          </>
        ) : (
          <Box 
            className={uploadProfilePicClasses}
            onClick={() => inputRef?.current?.click()}
            sx={{ cursor: 'pointer' }}
          >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <SvgCamera width="32px" height="32px" style={{ color: "#fff" }} />
                <Box color={"#fff"}>Upload Photo</Box>
              </Box>
          </Box>
        )}
      </Box>
      <FieldErrorMessage error={error} />
    </>
  );
};

export default UploadProfilePic;
